import React from "react";
import Image from "next/image";
import { slugify } from '@/lib/slugify';

export interface ServiceCard {
  image: string;
  title: string;
  description: string;
  button: {
    name: string;
    link: string;
  };
}

interface AdditionalServiceProps {
  cards: ServiceCard[];
  sectionId?: string;
}

const AdditionalService: React.FC<AdditionalServiceProps> = ({ cards, sectionId }) => {
  const id = sectionId || slugify('Unsere Zusatzservices');

  return (
    <section id={id} className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-dark mb-10 text-center">
          <a href={`#${id}`} className="group inline-flex items-center gap-2 hover:text-primary-dark">
            Unsere Zusatzservices
            <span className="text-primary-dark opacity-0 transition-opacity duration-200 group-hover:opacity-100">#</span>
          </a>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, idx) => (
            <div key={idx} className="flex flex-col items-center text-center bg-primary/5 rounded-2xl shadow-md p-6 transition hover:shadow-lg animate-fadeIn">
              <div className="mb-4 w-full flex justify-center">
                <Image src={card.image} alt={card.title} width={240} height={160} className="object-contain rounded-xl bg-white border border-primary-light p-2" />
              </div>
              <h3 className="text-lg font-semibold text-primary-dark mb-2">{card.title}</h3>
              <p className="text-gray-700 text-base leading-relaxed mb-4">{card.description}</p>
              <a href={card.button.link} className="inline-block bg-primary-light hover:bg-primary text-white font-semibold px-5 py-2 rounded-lg transition-all duration-200 shadow focus:outline-none">
                {card.button.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdditionalService;
